(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("@draftkings/dk-my-bets-list", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["@draftkings/dk-my-bets-list"] = factory(require("React"), require("ReactDOM"));
	else
		root["@draftkings/dk-my-bets-list"] = factory(root["React"], root["ReactDOM"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__3804__, __WEBPACK_EXTERNAL_MODULE__7196__) {
return 